import $ from 'jquery';
import 'datatables.net';

$(document).ready(function() {
    $('#games-table, #bets-table').DataTable({
        pageLength: 20,
        lengthChange: false,
        columnDefs: [
            { targets: [2], orderable: false }
        ],
    });
});
